import { Component, ViewChild, AfterViewInit, ChangeDetectorRef, inject } from '@angular/core';
import { tableModel } from '../../../components/table/model/tableModel';
import { TableComponent } from '../../../components/table/table.component';
import { Router } from '@angular/router';
import { AreaService } from '../../../services/area.service';
import { MatExpansionPanel } from '@angular/material/expansion';
import { FilterAreas } from '../../../models/filters/filter-areas';
import { AlertaService } from '../../../services/alerta.service';

@Component({
  selector: 'app-areas',
  standalone: false,
  templateUrl: './areas.component.html',
  styleUrl: './areas.component.css'
})
export class AreasComponent {

  @ViewChild(TableComponent) areasTable:TableComponent | undefined;
  @ViewChild('advancedPanel') advancedPanel!: MatExpansionPanel;
  
  tableModel: tableModel= {
    columnModel:[{columnName:'C\u00F3digo',columnValue:'code'},
      {columnName:'Descripci\u00F3n',columnValue:'description'},
      {columnName:'Activo',columnValue:'active'}],
    dataSource:[],
    editButton:true
  };

  pageIndex: number = 1;
  pageSize: number = 5;
  loading: boolean = false;
  filterAreas: FilterAreas = new FilterAreas;
  advancedSearch: boolean = false;

  //private offerService = inject(OfferService);
  private areaService = inject(AreaService);
  router = inject(Router);
  private cdr = inject(ChangeDetectorRef);
  private alerta = inject(AlertaService);
  
  constructor(
    //public dialog: MatDialog
  ){ 

  }

  ngAfterViewInit() {
    //Promise.resolve().then(() => this.areasTable.initTable());
  }
  ngOnInit(): void {
    this.searchAreasPaginator();
  }
  paginatorEvent(event: any){
    this.pageIndex = (event.pageIndex+1);
    this.pageSize = event.pageSize;
    this.searchAreasPaginator();
  }
  editEvent(event: any){
    this.router.navigate(['/areas/edit', event.id]);
    /*const dialogRef = this.dialog.open(AreasDetailComponent, {
      data: {
        area: event,
        readOnly: false
      }
    });*/
  }
  /*onShowAgregar(): void {
    const dialogRef = this.dialog.open(AreasDetailComponent, {
      data: {
        area: undefined,
        readOnly: false
      }
    });
  }*/

  searchAreasPaginator(){
    this.loading = true;

    this.areaService.findAllPageableAreas(this.filterAreas, this.pageIndex, this.pageSize).subscribe({
      next: (pageable) => {
        this.tableModel.pageSize = pageable.pageSize;
        this.tableModel.totalRecords = pageable.itemsCount;
        this.tableModel.dataSource = pageable.list;
        this.tableModel.pageNumber = pageable.pageNum;
        
        setTimeout(() => {
          this.areasTable?.refresh(pageable.list, pageable.itemsCount);
        });
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.loading = false;
        if(err.status == 400){
          this.alerta.error("Se ha terminado el tiempo de session: ", {detail: err.message});
          this.router.navigate(['/login']);
        }else{
          this.alerta.error("Se ha precentado un error interno: ", {detail: err.message});
        }
      }
    });

    if(this.advancedPanel != null){
      if (this.advancedSearch) {
        this.advancedPanel.open();
      } else {
        this.advancedPanel.close();
      }
    }
  }
}
